import { render, staticRenderFns } from "./SImage.vue?vue&type=template&id=6c780b96&scoped=true"
import script from "./SImage.vue?vue&type=script&lang=js"
export * from "./SImage.vue?vue&type=script&lang=js"
import style0 from "./SImage.vue?vue&type=style&index=0&id=6c780b96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c780b96",
  null
  
)

export default component.exports